import posthog from 'posthog-js'

export function usePostHog() {
  // Use environment variables only
  const apiKey = process.env.VUE_APP_POSTHOG_API_KEY
  const apiHost = process.env.VUE_APP_POSTHOG_API_HOST || 'https://us.i.posthog.com'
  
  if (!apiKey) {
    console.warn('PostHog API key not found. Please set VUE_APP_POSTHOG_API_KEY in your .env file')
    return { posthog: null }
  }
  
  posthog.init(apiKey, {
    api_host: apiHost,
    defaults: '2025-05-24',
    person_profiles: 'identified_only', // or 'always' to create profiles for anonymous users as well
  })

  return { posthog }
}

